import { ComparisonWidgetProps } from 'containers/Widgets/ComparisonWidget/ComparisonWidget'
import { InfoWidgetProps } from 'containers/Widgets/InfoWidget/InfoWidget'
import { PartToWholeWidgetProps } from 'containers/Widgets/PartToWholeWidget/PartToWholeWidget'
import { RankWidgetProps } from 'containers/Widgets/RankWidget/RankWidget'
import { WidgetRoutes } from './homeLayout'
import i18n from 'utils/i18n'

export type WidgetTransformer =
  | {
      type: 'info'
      transformer: (data: InfoWidgetProps['data']) => InfoWidgetProps['data']
    }
  | {
      type: 'rank'
      transformer: (data: RankWidgetProps['data']) => RankWidgetProps['data']
    }
  | {
      type: 'part-to-whole'
      transformer: (data: PartToWholeWidgetProps['data']) => PartToWholeWidgetProps['data']
    }
  | {
      type: 'comparison'
      transformer: (data: ComparisonWidgetProps['data']) => ComparisonWidgetProps['data']
    }

export const transformers: { [key in WidgetRoutes]?: WidgetTransformer } = {
  'ops:route:route_status': {
    type: 'part-to-whole',
    transformer: (data) => {
      return data?.map((item) => ({
        ...item,
        label: i18n.t(`pages.ops_management.cockpit.routes.statuses.${item.key}`),
      }))
    },
  },
}
